import React, { useContext, useEffect, useRef, useState } from "react";
import ImageGallery from "react-image-gallery";
import "./index.scss"; // ensure this SCSS file contains the necessary styles
import NavBar from "../../components/Navbarr";
import Footerr from "../../components/Footerr";
import "react-image-gallery/styles/css/image-gallery.css";
import { useParams } from "react-router-dom";
import { getSingleProd } from "../../services/get-single-product";
import { toast } from "react-toastify";
import ImageDisplay from "../../components/ImageDisplay";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getSingleProdWithImages } from "../../services/get-single-prod-with-photos";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getProductsBySubCategory } from "../../services/get-products-by-subCategory";
import Lottie from "react-lottie";
import {
  defaultOptionsEmpty,
  defaultOptionsLoading,
  defaultloadImage,
} from "../../assets/lottie-animations/animationOptions";
import { useSelector, useStore } from "react-redux";
import { Store } from "@reduxjs/toolkit";
import { api } from "../../config/baseApi";
import { getSinglePackageWithProds } from "../../services/get-single-package-with-prods";
import { UserContext } from "../../components/context/userContext";
const carouselSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function PackageDetailsScreen() {
  const [currentPackage, setCurrentPackage] = useState<any>();
  const [relatedProducts, setRelatedProducts] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [currentProductPhotos, setCurrentProductPhotos] = useState([]);
  const { packageId } = useParams();
  const scrollContainerRef = useRef(null);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const {networkError , setNetworkError} = useContext(UserContext)

  const doGetSingleProd = () => {
    setLoading(true);
    getSinglePackageWithProds(packageId)
      .then((response) => {
        setLoading(false);

        if (response?.status === 500) {
          setNetworkError(true)
          return;
        }
        if (!response?.success) {
          toast.error(response?.message);
          return;
        }
        if (response.success) {
          setCurrentPackage(response?.content?.packageWithRelatedProducts);
          setRelatedProducts(
            response?.content?.packageWithRelatedProducts?.relatedProducts,
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error);
      });
  };

  useEffect(() => {
    doGetSingleProd();
  }, []);

  // Example reviews data
  const reviews = {
    average: 4.9,
    total: 233,
    // ... more data
  };
  const images = [
    {
      original: "https://picsum.photos/id/1018/1000/600/",
      thumbnail: "https://picsum.photos/id/1018/250/150/",
    },
    {
      original: "https://picsum.photos/id/1015/1000/600/",
      thumbnail: "https://picsum.photos/id/1015/250/150/",
    },
    {
      original: "https://picsum.photos/id/1019/1000/600/",
      thumbnail: "https://picsum.photos/id/1019/250/150/",
    },
  ];
  // Example product data and reviews data
  // ...
  const scrollLeft = () => {
    scrollContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };
  const store = useStore() as Store;

  const imagesPhotoGalerie = () => {
    return currentProductPhotos.map((photo: any) => ({
      original: `data:${photo.contentType};base64,${photo.data}`,
      thumbnail: `data:${photo.contentType};base64,${photo.data}`,
    }));
  };

  const addProdToBasket = (product: any) => {
    if (typeof product == "object") {
      const objCopy = { ...product };
      objCopy.quantityInBasket = 1;
      objCopy.type = "package";

      try {
        store.dispatch({
          type: "basketSlice/add",
          payload: { product: objCopy },
        });
      } catch (error) {
      }
    }
  };

  const productsInBasket = useSelector(
    (state: Storage) => state?.entities?.basketSlice?.product,
  );

  const isProductInBasket = productsInBasket?.some(
    (item) => item?._id === packageId,
  );

  return (
    <div>
      <div>
        <NavBar />
      </div>
      {!loading ? (
        <>
          {currentPackage ? (
            <div className="product-details-container">
              <div className="product-display">
                <div className="product-image-gallery">
                  {/* <img src={api/} /> */}
                  {!isImageLoaded && (
                    <Lottie
                      options={defaultloadImage}
                      height={100}
                      width={100}
                    />
                  )}
                  <img
                    src={`${api}/package/photo/${currentPackage?._id}`}
                    alt={currentPackage?.name}
                    onLoad={() => setIsImageLoaded(true)}
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
                <div className="product-information">
                  <h1 className="product-title">{currentPackage?.name}</h1>

                  {currentPackage?.sold > 0 && (
                    <span style={{ color: "red" }}>
                      Sold : {currentPackage?.sold} %
                    </span>
                  )}

                  <p
                    className="product-price"
                    style={
                      currentPackage?.sold > 0
                        ? { textDecoration: "line-through" }
                        : {}
                    }
                  >
                    {currentPackage?.price?.toFixed(3)} DT
                  </p>
                  {currentPackage?.sold > 0 ? (
                    <p className="product-price">
                      {(
                        currentPackage?.price *
                        ((100 - currentPackage?.sold) / 100)
                      )?.toFixed(3)}{" "}
                      DT
                    </p>
                  ) : (
                    <></>
                  )}
                  <p className="product-description">
                    {currentPackage?.description}
                  </p>
                  {/* Add to Cart, Add to Wishlist Buttons */}
                  {/* Placeholder for the rating component */}
                  <div className="rating-summary">
                    {/* Stars and review count here */}
                    <div className="star-rating">
                      {/* Star icons based on the average rating */}
                    </div>
                    <div className="review-count">
                      <i
                        className="bx bx-star"
                        style={{
                          fontSize: 24,
                          marginRight: 20,
                          color: "green",
                        }}
                      ></i>
                      <p>{reviews.total} Reviews</p>
                    </div>
                  </div>
                  {/* Tabs for Reviews, Description, etc. */}
                  <div className="product-tabs">
                    {/* Placeholder for tabs */}
                    {isProductInBasket ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ fontSize: 28 }}>Ajoutée</span>
                        <i
                          className="bx bx-check-double"
                          style={{ fontSize: 36, color: "#be0" }}
                        ></i>
                      </div>
                    ) : (
                      <button
                        className="btn-add-to-basket"
                        onClick={() => addProdToBasket(currentPackage)}
                      >
                        <i
                          className="bx bx-basket"
                          style={{ fontSize: 28, marginRight: 15 }}
                        ></i>
                        <span style={{ fontSize: 18 }}>Ajouter au panier</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
              {/* Related Products Section */}
              <p style={{ textAlign: "center", fontSize: 32 }}>
                Related Products
              </p>
              <div className="related-products-section">
                <button onClick={scrollLeft} style={{ borderWidth: 0 }}>
                  <i
                    className="bx bx-chevron-left"
                    style={{ fontSize: 48 }}
                  ></i>
                </button>
                <div
                  ref={scrollContainerRef}
                  className="horizontal-scroll-container"
                >
                  {relatedProducts?.length > 0 ? (
                    relatedProducts
                      .filter(Boolean)
                      .map((product) => (
                        <div key={product?._id} className="product-card">
                          <img
                            className="product-image"
                            src={`${api}/product/photo/${product?._id}`}
                            alt={product?.name}
                          />
                          <h3>{product?.name}</h3>
                          <p>{product?.price} DT</p>
                        </div>
                      ))
                  ) : (
                    <></>
                  )}
                </div>
                <button onClick={scrollRight} style={{ borderWidth: 0 }}>
                  {" "}
                  <i
                    className="bx bx-chevron-right"
                    style={{ fontSize: 48 }}
                  ></i>
                </button>
              </div>
            </div>
          ) : (
            <div
              style={{
                minHeight: "80vh",
                width: "100vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <h2>No product found !</h2>
            </div>
          )}
        </>
      ) : (
        <div
          style={{
            height: "100%",
            width: "100%",
            paddingTop: 150,
            paddingBottom: 300,
          }}
        >
          <Lottie options={defaultOptionsLoading} height={170} width={170} />
        </div>
      )}
      <div>
        <Footerr />
      </div>
    </div>
  );
}

export default PackageDetailsScreen;
